/**
 * Created by liuxsen on 2017/9/23.
 */
function isMobile(phone) {
  // 根据号码段的不同和前缀不同可适当修改
  var reValue = /^(0|86|17951)?(13[0-9]|15[012356789]|18[0-9]|14[57]|17[0-9])[0-9]{8}$/;
  if (!reValue.test(phone)) {
    return false;
  } else {
    return true;
  }
}

function isEmail(email) {
  // @符号前后直接相邻不能为 .
  var reEmail = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
  if (!reEmail.test(email)) {
    return false;
  } else {
    return true;
  }
}
/**
 * 获取url 字符串中的查询字段
 * @param url
 * @param name
 * @returns {null}
 */
function getQueryString(url, name) {
  var reg = new RegExp("(^|&|\\?)" + name + "=([^&]*)(&|$)", "i");
  var r = url.substr(1).match(reg);
  if (r != null) return unescape(r[2]); return null;
}

export default {isMobile,isEmail,getQueryString};



// WEBPACK FOOTER //
// ./src/plugin/extendFn/util.js